<template>
  <OptionSummary></OptionSummary>
  <section class="products-banner-section">
    <videoBanner
      :videoObj="themeInfo.info?.videoBanners?.productsPage"
      :displayStyle="'productsPage'"
      v-if="themeInfo.info?.videoBanners?.productsPage"
    />
    <SellerBanner :pageName="'showInProductsPage'" v-else></SellerBanner>
  </section>

  <div class="products-list-section">
    <div class="title">
      <h2>محصولات / خدمات</h2>
      <hr class="title-separator" />
    </div>

    <ul class="products-list">
      <div ref="categoryBox">
        <categorySliderReact
          :class="{ fixed_position: this.categoryPositionIsFix }"
          v-if="
            themeInfo?.info?.productsCategory &&
            themeInfo?.info?.productsCategory.length > 0
          "
          :categoryList="themeInfo?.info?.productsCategory"
          :categoryType="'productsCategory'"
          @selectedCategory="selectedCategory = $event"
        >
        </categorySliderReact>
      </div>
      <ProductCard
        :key="0"
        :product="newProduct"
        v-if="managerMode == 'dataEdit'"
      >
      </ProductCard>
      <template v-if="themeInfo?.info?.productsCategory.length > 0">
        <template
          v-for="(categoryItem, index) in themeInfo?.info?.productsCategory"
          :key="index"
        >
          <li>
            <p
              :id="categoryItem.category_name"
              :style="index == 0 ? 'margin-bottom:2rem' : 'margin-bottom: 8rem'"
            ></p>
            <p
              class="product-category"
              style="
                font-weight: 600;
                font-size: 1rem;
                margin-top: 0rem;
                margin-bottom: 0.5rem;
              "
            >
              {{ categoryItem.category_name }}
            </p>

            <div
              style="
                width: 90%;
                border-bottom: solid 0.2rem rgba(0, 0, 0, 0.2);
                margin-top: 0.5rem;
                margin-bottom: 2rem;
                margin-inline: auto;
              "
            ></div>
            <template
              v-for="(product, index2) in themeInfo.info?.products"
              :key="index2"
            >
              <ProductCard
                :product="product"
                v-if="
                  isInCategory(product.category, categoryItem.category_name)
                "
              ></ProductCard>
            </template>
          </li>
        </template>
      </template>
      <template v-else>
        <ProductCard
          v-for="(product, index) in themeInfo.info?.products"
          :key="index + 1"
          :product="product"
        >
        </ProductCard>
      </template>
    </ul>
  </div>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
import ProductCard from "@/components/ProductCard/index.vue";
import SellerBanner from "@/components/SellerBanner/index.vue";
import videoBanner from "@/components/videoBanner/index.vue";
import { productsData } from "@/repo/productsData";
import { mapGetters } from "vuex";
import { publicHelpers } from "@/public/helpers";
import categorySliderReact from "@/components/categorySliderReact/index.vue";

export default {
  name: "ProductsPage",
  components: {
    OptionSummary,
    ProductCard,
    SellerBanner,
    videoBanner,
    categorySliderReact,
  },
  mixins: [productsData, publicHelpers],
  data() {
    return {
      a: 20,
      selectedCategory: "",
      categoryPositionIsFix: false,
    };
  },
  // watch: {
  //   selectedCategory(newQuestion, oldQuestion) {
  //     //if (newQuestion.includes('?')) {
  //     //alert(newQuestion);
  //     this.$router.push("#" + newQuestion);
  //     this.$router.push({ hash: "#" + newQuestion });
  //     //}
  //   },
  // },
  methods: {
    sc(e) {
      console.log(e);
    },
    isInCategory(a, b) {
      let isFounded = a.some((v) => b.includes(v));
      return isFounded;
    },
    updateScroll() {
      //this.scrollPosition = window.scrollY;
      // console.log(
      //   "TOP >>>>>" + this.$refs.categoryBox?.getBoundingClientRect()?.top
      // );

      if (
        this.$refs?.categoryBox?.getBoundingClientRect()?.top < 0 &&
        this.categoryPositionIsFix == false
      ) {
        this.categoryPositionIsFix = true;
        //console.log("TRUE");
      }
      if (
        this.$refs?.categoryBox?.getBoundingClientRect()?.top > 0 &&
        this.categoryPositionIsFix == true
      ) {
        this.categoryPositionIsFix = false;
        //console.log("FALSE");
      }
    },
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      managerMode: "managerMode",
    }),
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/products/products.css);
</style>
